module.exports = __webpack_public_path__ + "img/912-e2aabf.png";